import React from 'react';
import {useSelector} from "react-redux";
import PublicCoupon from "@/Modals/CouponModals/PublicCoupon";
import PublicMerchant from "@/Modals/MerchantModals/PublicMerchant";
import UnpublishMerchant from "@/Modals/MerchantModals/UnpublishMerchant";
import UploadImage from "@/Modals/Assets/UploadImage";
import ShowImage from '@/Modals/Assets/ShowImage';
import MultipleActionModal from '@/Modals/Assets/MultipleActionModal';
import AddCouponsToCategory from "@/Modals/CategoryModals/AddCouponsToCategory";
import FindCouponModal from '@/Modals/CategoryModals/FindCouponModal';

const BodyModal = () => {
  const state = useSelector(state => state.modal);

  switch (state.modalType) {
    case 'coupon-publication':
      return <PublicCoupon id={state.modalProps.id}/>;
    case 'merchant-publication':
      return <PublicMerchant id={state.modalProps.id}/>;
    case 'merchant-unpublication':
      return <UnpublishMerchant id={state.modalProps.id}/>
    case 'upload-image':
      return <UploadImage/>
    case 'show-image':
      return <ShowImage src={state.modalProps.src}/>
    case 'multiple-coupon-modal':
      return <MultipleActionModal id={state.modalProps.id} ids={state.modalProps.ids} url={state.modalProps.url} text={state.modalProps.text}/>;
    case 'add-to-category':
      return <AddCouponsToCategory id={state.modalProps.id} couponCategories={state.modalProps.couponCategories}/>;
      case  'find-coupon':
        return <FindCouponModal categoryId={state.modalProps.categoryId}/>
    default:
      return null;
  }
};

export default BodyModal;
